import React, { useEffect, useState, useMemo } from 'react';
import { getData } from '../../../services/library';
import { Container, Typography, Box, Button, MenuItem, ListItemIcon, Divider, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@mui/material';
import swal from 'sweetalert';
import Navbar from '../../Navbar';
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import PeopleIcon from '@mui/icons-material/People';
import AddProductos from './AddProductos';
import EditarProductos from './EditarProductos';
import { logEventos } from '../../../services/services';
import { UrlApi } from '../../../services/apirest';

const productoDeBaja = (producto) => Number(producto?.activo) === 0;

export default function Productos() {
    const globalTheme = useTheme();
    const [productos, setproductos] = useState([{}]);
    const [datosformulario, setDatosformulario] = useState({});
    const [alta, setAlta] = useState(false);
    const [tabla, setTabla] = useState(true);
    const [editar, setEditar] = useState(false);
    const [confirmacion, setConfirmacion] = useState({
        open: false,
        producto: null,
        activo: null,
    });
    const [cambiandoEstado, setCambiandoEstado] = useState(false);

    const getProductos = () => {
        getData('/productos', setproductos)
    };

    useEffect(() => {
        getProductos()
    }, [tabla]);

    const handleShowFormAdd = () => {
        setAlta(true);
    };

    const handleShowFormEdit = (rowData) => {
        setEditar(true);
        setTabla(true)
        setDatosformulario(rowData);
    };

    const abrirConfirmacionEstado = (producto, activo) => {
        setConfirmacion({ open: true, producto, activo });
    };

    const cerrarConfirmacionEstado = () => {
        if (cambiandoEstado) return;
        setConfirmacion({ open: false, producto: null, activo: null });
    };

    const textoConfirmacionEstado = () => {
        const { producto, activo } = confirmacion;
        if (!producto) return "";
        const accion = activo === 1 ? "alta" : "baja";
        const nombre = producto.nombre?.trim() || producto.codigoproducto || "este producto";
        return `¿Está seguro que desea dar de ${accion} al producto ${nombre}?`;
    };

    const handleConfirmarCambioEstado = async () => {
        const { producto, activo } = confirmacion;
        if (!producto?.idproducto || activo === null) return;

        setCambiandoEstado(true);
        const esAlta = activo === 1;
        try {
            const response = await fetch(UrlApi + "/productos/" + producto.idproducto, esAlta
                ? {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ activo: 1 }),
                }
                : { method: "DELETE" }
            );
            const json = await response.json().catch(() => ({}));
            if (!response.ok || json.sqlMessage) {
                throw new Error("No se pudo actualizar el estado del producto.");
            }
            logEventos(
                esAlta ? "Reactivar producto" : "Baja producto",
                "Tablas Referencias",
                "Productos",
                localStorage.getItem("user")
            );
            await swal({
                title: esAlta ? "Alta exitosa" : "Baja exitosa",
                text: `El producto fue dado de ${esAlta ? "alta" : "baja"} correctamente.`,
                icon: "success",
                closeOnClickOutside: false,
            });
            setConfirmacion({ open: false, producto: null, activo: null });
            getProductos();
        } catch (err) {
            swal({
                title: "No se pudo actualizar el estado",
                text: err.message || "Ocurrió un error al cambiar el estado del producto",
                icon: "error",
                closeOnClickOutside: false,
            });
        } finally {
            setCambiandoEstado(false);
        }
    };

    const columns = useMemo(() =>
        [{ header: '#', accessorKey: 'idproducto', size: 85 },
        { header: 'Código', accessorKey: 'codigoproducto', size: 85 },
        { header: 'Producto', accessorKey: 'nombre' },
        { header: 'Uso', accessorKey: 'valor' },
        {
            header: 'Estado',
            accessorKey: 'activo',
            size: 110,
            Cell: ({ cell }) => (Number(cell.getValue()) === 0 ? "Baja" : "Vigente"),
        },
        ], []);

    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: globalTheme.palette.mode,
                    primary: globalTheme.palette.primary, //primary color for the table
                    info: {
                        main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
                    },
                    background: {
                        default:
                            globalTheme.palette.mode === "light"
                                ? "rgb(234, 239, 241)"
                                : "#000", //pure black table in dark mode for fun
                    },
                },
                typography: {
                    button: {
                        textTransform: "none", //customize typography styles for all buttons in table by default
                        fontSize: "1rem",
                    },
                },
                components: {
                    MuiTooltip: {
                        styleOverrides: {
                            tooltip: {
                                fontSize: "0.8rem", //larger tooltip font size                                
                            },
                        },
                    },
                },

            }), [globalTheme]);

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "success",
        size: "small",
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 10 }
    };

    const tableHeadCellProps = {
        align: "left",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };


    useEffect(() => {
  logEventos(
    "acceso al menú Productos", 
  "Tablas Referencias",
   "Productos",
    localStorage.getItem("user"));
}, []);
    return (
        <div>
            <Navbar />
            <Container maxWidth="xl" mt={1} mb={2}>
                {productos && tabla &&
                    <Box mt={2} boxShadow={3}>
                        <ThemeProvider theme={tableTheme}>
                            <MaterialReactTable
                                columns={columns}
                                data={productos}
                                enableColumnResizing
                                initialState={initialState}
                                positionActionsColumn='last'
                                enableExpandAll={false}
                                enableToolbarInternalActions={true}
                                enableEditing={false}
                                enableRowActions
                                muiTableHeadCellProps={tableHeadCellProps}
                                muiTableBodyCellProps={({ row }) => ({
                                    align: "left",
                                    sx: {
                                        backgroundColor: productoDeBaja(row.original) ? "#efc3c3" : "#b3e6b3",
                                        color: "black",
                                        borderColor: "black",
                                    },
                                })}
                                enableDensityToggle={false}
                                renderTopToolbarCustomActions={() => (
                                    <>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddBoxTwoToneIcon />}
                                            onClick={handleShowFormAdd}>
                                            Nuevo Registro
                                        </Button>
                                        <Typography variant="poster" fontSize={26}>
                                            <PeopleIcon sx={{ size: 20 }} />
                                            Productos
                                        </Typography>
                                    </>
                                )}
                                muiSearchTextFieldProps={muiSearchTextFieldProps}
                                layoutMode='grid'
                                localization={MRT_Localization_ES}
                                enableColumnDragging={false}
                                renderRowActionMenuItems={({ closeMenu, row }) => (
                                    [
                                        <MenuItem
                                            key="editar"
                                            onClick={() => {
                                                handleShowFormEdit(row.original);
                                                closeMenu();
                                            }}>
                                            <ListItemIcon>
                                                <EditIcon color="primary" />
                                            </ListItemIcon>
                                            Editar
                                        </MenuItem>,
                                        <Divider key="sep" />,
                                        productoDeBaja(row.original) ? (
                                            <MenuItem
                                                key="reactivar"
                                                onClick={() => {
                                                    abrirConfirmacionEstado(row.original, 1);
                                                    closeMenu();
                                                }}>
                                                <ListItemIcon>
                                                    <CheckCircleOutlineIcon color="success" />
                                                </ListItemIcon>
                                                Dar de alta
                                            </MenuItem>
                                        ) : (
                                            <MenuItem
                                                key="baja"
                                                onClick={() => {
                                                    abrirConfirmacionEstado(row.original, 0);
                                                    closeMenu();
                                                }}>
                                                <ListItemIcon>
                                                    <BlockIcon color="error" />
                                                </ListItemIcon>
                                                Dar de baja
                                            </MenuItem>
                                        ),
                                    ]
                                )} />
                        </ThemeProvider>
                    </Box>
                }

                {alta && <AddProductos datos={datosformulario} open={setAlta} actualizar={getProductos} tabla={setTabla}/>}
                {editar && <EditarProductos datos={datosformulario} open={setEditar} tabla={setTabla} actualizar={getProductos}/>}

                <Dialog
                    open={confirmacion.open}
                    onClose={cerrarConfirmacionEstado}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle sx={{ fontWeight: 700 }}>
                        {confirmacion.activo === 1 ? "Confirmar alta" : "Confirmar baja"}
                    </DialogTitle>
                    <DialogContent>
                        <Typography>{textoConfirmacionEstado()}</Typography>
                        {confirmacion.producto?.codigoproducto ? (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                Código: {confirmacion.producto.codigoproducto}
                            </Typography>
                        ) : null}
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button
                            onClick={cerrarConfirmacionEstado}
                            color="inherit"
                            disabled={cambiandoEstado}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color={confirmacion.activo === 1 ? "primary" : "error"}
                            onClick={handleConfirmarCambioEstado}
                            disabled={cambiandoEstado}
                            startIcon={
                                cambiandoEstado ? <CircularProgress size={18} color="inherit" /> : null
                            }
                        >
                            {cambiandoEstado
                                ? "Procesando..."
                                : confirmacion.activo === 1
                                    ? "Dar de alta"
                                    : "Dar de baja"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </div>
    )
}
